import formatCurrency, {
    CurrencyFormatKeys,
    AmountValue,
} from '@mediaingenuity/totallymoney.formatcurrency'

function formatNumberToCurrency(
    amountValue: AmountValue,
    currencyFormat?: CurrencyFormatKeys
): string {
    return formatCurrency(amountValue, currencyFormat)
}

export default formatNumberToCurrency
